import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { useModalStore } from '@/store';
import Text from '@/components/Typography/Text';
import ChatInputBanner from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

const styles = StyleSheet.create({
  link: {
    marginLeft: 4,
    display: 'inline',
    textDecorationLine: 'underline',
  },
});

/**
 * Logged-out CTA banner — shown above the composer for anonymous visitors.
 * Replaces the legacy `ChatInputGhostBanner` (which targeted the now-retired
 * ghost-user flow). Tapping the link opens the contextual `AuthCTAModal`.
 */
function ChatInputAuthCTABanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();

  const handlePress = () => {
    openModal('AuthCTAModal', {
      source: 'composer_banner',
      title: t('chatInput.authCta.modalTitle'),
      subtitle: t('chatInput.authCta.modalSubtitle'),
      icon: 'message-dots',
    });
  };

  return (
    <ChatInputBanner color="tertiary" level={level} isCloseable={isCloseable} isDetached={isDetached}>
      {t('chatInput.authCta.bannerMessage')}
      <Pressable onPress={handlePress}>
        <Text size="s" weight="medium" color="primary" style={styles.link}>
          {t('chatInput.authCta.bannerLink')}
        </Text>
      </Pressable>
    </ChatInputBanner>
  );
}

export default React.memo(ChatInputAuthCTABanner);
